/**
 * @file Column component for displaying a requirement column
 * @author Heino Lenting
 */
import * as tslib_1 from "tslib";
import { ChangeDetectorRef } from '@angular/core';
import { ColumnBase } from '../../base/columns/column-base/column-base';
import { ColumnProvider } from '../../base/column-provider';
import { ComponentRegistry } from '../../core/component-registry';
/**
 * Column component for displaying a requirement value
 */
var ColumnRequirementComponent = /** @class */ (function (_super) {
    tslib_1.__extends(ColumnRequirementComponent, _super);
    /**
     * Constructs a ColumnRequirementComponent.
     * @param provider Provides the configuration information for the column.
     */
    function ColumnRequirementComponent(provider, changeDetector) {
        var _this = _super.call(this, provider, changeDetector) || this;
        _this.entity = _this.provider.entity;
        return _this;
    }
    /**
     * Register this column class for the column provider.
     */
    ColumnRequirementComponent.register = function () {
        ComponentRegistry.register('column', 'requirement', ColumnRequirementComponent);
    };
    Object.defineProperty(ColumnRequirementComponent.prototype, "description", {
        get: function () {
            var category = this.provider.value;
            if (!category) {
                return '';
            }
            var value = category['Name'];
            if (category.entityType.shortName === 'Location') {
                value = category['ZipCode'] === '' ? value : category['ZipCode'] + ' ' + value;
                value = category['HouseNumber'] === '' ? value : category['HouseNumber'] + ' ' + value;
                value = category['Address'] === '' ? value : category['Address'] + ' ' + value;
            }
            return value;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * The type of the requirement
     */
    ColumnRequirementComponent.prototype.getType = function () {
        var category = this.provider.value;
        if (!category) {
            return 'unkown';
        }
        switch (category.entityType.shortName) {
            case 'Team':
                return 'department';
            case 'Function':
                return 'competence';
            case 'Location':
                return 'location';
            default:
                return 'unkown';
        }
    };
    return ColumnRequirementComponent;
}(ColumnBase));
export { ColumnRequirementComponent };
